// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".components-base-control + .clickable-icon.inline-suffix {\n  margin-bottom: 15px;\n}\n\n.clickable-icon.icon-container {\n  cursor: pointer;\n}\n.clickable-icon.icon-container.inline-suffix {\n  display: inline-block;\n  margin-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
